/**
 * Sanitize email input by removing spaces and fixing consecutive dots
 * @param {string} email - The email string to sanitize
 * @returns {string} - Email with spaces removed and consecutive dots replaced by single dot
 */
export function sanitizeEmailInput(email) {
  if (typeof email !== 'string') {
    return '';
  }

  return email
    .replace(/\s/g, '') // Remove all spaces (including tabs, newlines, etc.)
    .replace(/\.+/g, '.'); // Replace any sequence of dots with single dot
}
